import React from "react";
import { Typography } from "@mui/material";
import ModalWrap from "./ModalWrap";
import { pageLocale } from "../../utlis/locale";
import "./recorduploadchoice.scss";

const RecordUploadChoice = ({ open, onClose, onRecord, onUpload }) => {
  const t = pageLocale("recordUploadChoice");
  return (
    <ModalWrap open={open} onClose={onClose} className="record-upload-modal">
      <div className="record-upload-choice-wrapper">
        <Typography className="modal-title">{t?.title}</Typography>
        <Typography className="modal-subtitle">{t?.subtitle}</Typography>

        <div className="choice-buttons">
          <button className="choice-btn record-btn" onClick={onRecord}>
            <div className="btn-icon record-icon">
              <div className="record-dot"></div>
            </div>
            <div className="btn-content">
              <Typography className="btn-title">{t?.record_video}</Typography>
              <Typography className="btn-description">
                {t?.record_video_desc}
              </Typography>
            </div>
          </button>

          <button className="choice-btn upload-btn" onClick={onUpload}>
            <div className="btn-icon upload-icon">
              <svg
                width="32"
                height="32"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 15V3M12 3L8 7M12 3L16 7"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2 17L2 19C2 20.1046 2.89543 21 4 21L20 21C21.1046 21 22 20.1046 22 19V17"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div className="btn-content">
              <Typography className="btn-title">{t?.upload_video}</Typography>
              <Typography className="btn-description">
                {t?.upload_video_desc}
              </Typography>
            </div>
          </button>
        </div>

        <button className="cancel-modal-btn" onClick={onClose}>
          {t?.cancel}
        </button>
      </div>
    </ModalWrap>
  );
};

export default RecordUploadChoice;
